// src/components/FeatureBanner.jsx
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../theme"; // keeps Playfair + Roboto / Crimson stack defined

export default function FeatureBanner() {
  return (
    <ThemeProvider theme={theme}>
      <Box component="section" sx={{ py: { xs: 3, md: 4 }, backgroundColor: "custom.blue" }}>
        <Container maxWidth="lg" sx={{ display: "flex", justifyContent: "center" }}>
          <Box sx={{ maxWidth: 1120, width: "100%" }}>
            <Box id="row-b777d998" sx={{ textAlign: "center" }}>
              <Typography
                id="headline-bde78b28"
                sx={{
                  fontSize: { xs: "1.05rem", md: "31px" },
                  lineHeight: 1.05,
                  fontWeight: 400,
                  color: "text.primary",
                  mb: 1,
                }}
              >
                <strong>・COMPASSION・RESILIENCE・GRATITUDE・GROWTH・HOPE・</strong>
              </Typography>

              {/* Empty paragraph slot preserved from the original fragment — keep if you want small caption */}
              <Typography
                id="text-ac319f4d"
                sx={{
                  fontSize: { xs: "0.95rem", md: "18px" },
                  color: "primary.main",
                  mt: 0.5,
                }}
                aria-hidden="true"
              >
                {/* intentionally empty to match original layout; add content here if needed */}
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
